module.exports = __webpack_public_path__ + "img/alert-fireabase.779dc5b3.svg";